import { useTranslation } from 'react-i18next';

import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import { useNovel } from '@/context/novel-context';
import { CollaborationAddForms } from './collaboration-add-forms';
import { CollaborationMemberList } from './collaboration-member-list';
import { useCollaboration } from './use-collaboration';



export function CollaborationSettingsSection() {
  const { t } = useTranslation();
  const { novel } = useNovel();
  if (!novel.id) {
    throw new Error('useCollaboration must be used within a NovelProvider with a loaded novel.');
  }
  const {
    user,
    isCurrentUserOwner,
    newCollabEmail,
    setNewCollabEmail,
    newReaderEmail,
    setNewReaderEmail,
    collabError,
    readerError,
    isUpdatingCollab,
    isUpdatingReader,
    updatingCollabMemberId,
    updatingReaderMemberId,
    handleAddCollaborator,
    handleRemoveCollaborator,
    handleRemovePendingCollaborator,
    handleAddReader,
    handleRemoveReader,
    handleRemovePendingReader,
  } = useCollaboration();

  return (
    <Accordion
      sx={{
        mt: 3,
        borderRadius: 3,
        border: '1px solid',
        borderColor: 'divider',
        '&:before': { display: 'none' },
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        sx={{
          borderRadius: 3,
          '& .MuiAccordionSummary-content': { my: 1.5 },
        }}
      >
        <Typography variant="h3" sx={{ fontSize: '1.25rem', fontWeight: 600 }}>
          {t('dashboard.settings.collaboration_title')}
        </Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ px: 3, pb: 4 }}>
        <Grid container spacing={4}>
          <Grid size={{ xs: 12, md: 7 }}>
            <CollaborationMemberList
              currentUserUid={user?.uid}
              currentUserEmail={user?.email}
              isCurrentUserOwner={isCurrentUserOwner}
              isUpdatingCollab={isUpdatingCollab}
              isUpdatingReader={isUpdatingReader}
              updatingCollabMemberId={updatingCollabMemberId}
              updatingReaderMemberId={updatingReaderMemberId}
              onRemoveCollaborator={handleRemoveCollaborator}
              onRemoveReader={handleRemoveReader}
              onRemovePendingCollaborator={handleRemovePendingCollaborator}
              onRemovePendingReader={handleRemovePendingReader}
            />
          </Grid>
          <Grid size={{ xs: 12, md: 5 }}>
            <CollaborationAddForms
              isCurrentUserOwner={isCurrentUserOwner}
              newCollabEmail={newCollabEmail}
              setNewCollabEmail={setNewCollabEmail}
              newReaderEmail={newReaderEmail}
              setNewReaderEmail={setNewReaderEmail}
              collabError={collabError}
              readerError={readerError}
              isUpdatingCollab={isUpdatingCollab}
              isUpdatingReader={isUpdatingReader}
              onAddCollaborator={handleAddCollaborator}
              onAddReader={handleAddReader}
            />
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
}
